/** The event name of RPC messages which support transferables */
export const MESSAGE_TYPE_RPC_TRANSFERABLE = 'RPC_transferable';
